import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from '../../../services/core.service';
import { AuthService } from '../../../keycloack/auth.service';
import { ITenant } from '../../../types/ITenant';
import { ROLES } from '../../../utils/constants';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent implements OnInit {
  tenant: ITenant | null = null;
  showAvatar = true;

  constructor(private router: Router, private coreService: CoreService, private authService: AuthService) {}

  ngOnInit(): void {
    if (this.authService.hasRole(ROLES.superadmin)) {
      this.showAvatar = false;
      return;
    }
    this.coreService.getTenantMe().subscribe({
      next: (t) => (this.tenant = t),
      error: () => {},
    });
  }

  get avatarUrl(): string {
    if (this.tenant?.avatarUrl) return this.tenant.avatarUrl;
    const name = this.tenant?.name || 'Tenant';
    return `https://placehold.co/120x120?text=${encodeURIComponent(name)}`;
  }

  get errorAvatarUrl(): string {
    if (this.tenant?.avatarErrorUrl) return this.tenant.avatarErrorUrl;
    return this.avatarUrl;
  }

  isErrorPage() {
    return this.router.url.includes('error');
  }
}
